import { RouterModule, Routes } from "@angular/router";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { PricingPlanComponent } from "./pricing-plan.component";
import { PricingTableComponent } from "src/app/components/pricing-table/pricing-table.component";

const routes: Routes = [
    {
      path: '',
      component: PricingPlanComponent
    }
  ];
  
  @NgModule({
    declarations: [
        PricingPlanComponent,
        PricingTableComponent
    ],
    imports: [
      CommonModule,
      SharedModule,
      RouterModule.forChild(routes),
    ],
    exports:[
        PricingPlanComponent,
        
    ],
    schemas:[
        NO_ERRORS_SCHEMA
    ]
  })
  export class PricingModule { }